/**
 * Reset Password Page for trAInedup.ai
 * Renders the reset password form using the shared layout
 */

import React from 'react';
import { Layout } from '../components/common/Layout';
import { ResetPasswordForm } from '../components/auth/ResetPasswordForm';

export const ResetPasswordPage: React.FC = () => {
  return (
    <Layout showFooter={false}>
      <div className="min-h-screen bg-gradient-to-br from-primary-50 to-secondary-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
        <div className="w-full max-w-md">
          <ResetPasswordForm />
        </div>
      </div>
    </Layout>
  );
};

export default ResetPasswordPage;
